export default "__VITE_ASSET__85bd8d38__"